import logoNE from '../logo/NEQOC.png';
import logoMO from '../logo/MOQOC.png';
import logoNC from '../logo/NCQOC_HealthyBlue.png';


const getLogogSrc = (stateCode) => {
    let url = '';
    switch (stateCode) {
        case 'NE':
            url = logoNE;
            break;
        case 'MO':
            url = logoMO;
            break;
        case 'NC':
            url = logoNC;
            break;
        default:
            url = '';
    }
    return url
}

export default getLogogSrc;